export default __webpack_public_path__ + "static/media/success.a3c33c51.png";